module.exports = __webpack_public_path__ + "img/motorcycle-purple.f75547a0.svg";